// Material Events Card — PSD §9.5 (F9.5). Dashboard.

import { useState } from 'react';
import type { Alert } from '../../persistence/schema';
import { Tooltip } from '../common/Tooltip';

interface MaterialEventsCardProps {
  alerts: Alert[];
  onRegister?: ((message: string) => void) | undefined;
  onAcknowledge?: ((alertId: string) => void) | undefined;
}

export function MaterialEventsCard({ alerts, onRegister, onAcknowledge }: MaterialEventsCardProps) {
  const [message, setMessage] = useState('');
  const eventAlerts = alerts.filter((a) => a.kind === 'materialEvent');

  return (
    <div className="card material-events-card">
      <h3>
        Material Events
        <Tooltip
          label="Events that may affect FMV (new financing, acquisition, layoff, etc.). Registering one is good safe-harbor practice and may trigger a refresh."
          ariaLabel="Help: Material Events"
        />
      </h3>

      {onRegister && (
        <div className="form-row">
          <input
            type="text"
            placeholder="e.g. New financing round closed"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            aria-label="Material event description"
          />
          <button
            className="btn btn-secondary"
            onClick={() => {
              if (message.trim()) {
                onRegister(message.trim());
                setMessage('');
              }
            }}
          >
            Register
          </button>
        </div>
      )}

      {eventAlerts.length === 0 ? (
        <p className="field-hint">No material events registered.</p>
      ) : (
        <ul className="mt-3">
          {eventAlerts.map((a) => (
            <li key={a.id} className={`alert-row ${a.acknowledged ? 'acknowledged' : ''}`}>
              <span className="badge badge-info">Event</span>
              <span>{a.message}</span>
              <span className="timestamp">{a.raisedAt.slice(0, 10)}</span>
              {!a.acknowledged && onAcknowledge && (
                <button className="btn btn-ghost btn-sm" onClick={() => onAcknowledge(a.id)}>
                  Dismiss
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
